// 用户组显示辅助函数

export interface UserGroup {
  id: number;
  name: string;
  description?: string;
  role?: string;
  badge_color?: string;
  nickname_color?: string;
  permissions?: any;
  sort_order?: number;
}

/**
 * 获取用户组颜色（从用户组数据中获取）
 * @param userGroups 用户组列表
 * @param userGroupId 用户组ID
 * @returns 用户组颜色对象
 */
export const getUserGroupColors = (userGroups: UserGroup[], userGroupId: number | null) => {
  if (!userGroupId || userGroups.length === 0) {
    return {
      badgeColor: '#6B7280',
      nicknameColor: '#111827',
      role: ''
    };
  }

  const group = userGroups.find(g => g.id === userGroupId);
  if (!group) {
    return {
      badgeColor: '#6B7280',
      nicknameColor: '#111827',
      role: ''
    };
  }

  return {
    badgeColor: group.badge_color || '#6B7280',
    nicknameColor: group.nickname_color || '#111827',
    role: group.role || ''
  };
};

/**
 * 生成用户组显示的Tailwind颜色类
 * @param hexColor 十六进制颜色值
 * @returns Tailwind样式对象
 */
export const getTailwindStyleFromHex = (hexColor: string) => {
  if (!hexColor || !/^#[0-9A-Fa-f]{6}$/.test(hexColor)) {
    return {};
  }

  return {
    color: hexColor,
    backgroundColor: hexColor + '20', // 添加透明度为20%的背景色
  };
};

/**
 * 判断颜色是否为深色（用于确定文字颜色）
 * @param hexColor 十六进制颜色值
 * @returns 是否为深色
 */
export const isDarkColor = (hexColor: string): boolean => {
  if (!hexColor || !/^#[0-9A-Fa-f]{6}$/.test(hexColor)) {
    return true;
  }

  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  // 使用亮度公式计算
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 128;
};

/**
 * 预定义的颜色选项
 */
export const PREDEFINED_COLORS = [
  { name: '红色', value: '#EF4444' },
  { name: '橙色', value: '#F97316' },
  { name: '黄色', value: '#EAB308' },
  { name: '绿色', value: '#22C55E' },
  { name: '青色', value: '#06B6D4' },
  { name: '蓝色', value: '#3B82F6' },
  { name: '紫色', value: '#8B5CF6' },
  { name: '粉色', value: '#EC4899' },
  { name: '灰色', value: '#6B7280' },
  { name: '黑色', value: '#111827' },
  { name: '深红色', value: '#DC2626' },
  { name: '深橙色', value: '#EA580C' },
  { name: '深黄色', value: '#CA8A04' },
  { name: '深绿色', value: '#16A34A' },
  { name: '深蓝色', value: '#2563EB' },
  { name: '深紫色', value: '#7C3AED' },
  { name: '深粉色', value: '#DB2777' },
];